(()=>{'use strict';
const init=(root)=>{
 const host=root.querySelector('[data-topg-hero-carousel]');
 if(!host||host.dataset.carouselReady==='1')return;
 host.dataset.carouselReady='1';
 const slides=Array.from(host.querySelectorAll('[data-topg-hero-slide]'));
 if(slides.length<2){
  const only=slides[0]?.querySelector('video');
  if(only){
    only.muted=true;only.playsInline=true;
    only.addEventListener('playing',()=>only.classList.add('topg-video-ready'),{once:true});
    only.play().catch(()=>only.classList.remove('topg-video-ready'));
  }
  return;
}
 const control=host.querySelector('[data-topg-hero-controls]');
 const dots=host.querySelector('[data-topg-hero-dots]');
 const reduce=matchMedia('(prefers-reduced-motion: reduce)');
 const interval=Math.max(3000,Number(host.dataset.interval)||3000);
 let index=0,timer=0,delayTimer=0,xStart=null;
 control.hidden=false;
 dots.replaceChildren();
 const buttons=slides.map((_,i)=>{
  const button=document.createElement('button');
  button.type='button';button.setAttribute('aria-label','Slide '+(i+1));
  button.addEventListener('click',()=>go(i,true));dots.appendChild(button);return button;
 });
 function sync(){
  const upcoming=slides[(index+1)%slides.length]?.querySelector('img');
  if(upcoming)upcoming.loading='eager';
  slides.forEach((slide,i)=>{
    const active=i===index;
    slide.classList.toggle('is-active',active);
    slide.setAttribute('aria-hidden',String(!active));
    const video=slide.querySelector('video');
    if(video){
      if(active&&!document.hidden){
        video.muted=true;
        video.playsInline=true;
        video.addEventListener('playing',()=>video.classList.add('topg-video-ready'),{once:true});
        video.play().catch(()=>video.classList.remove('topg-video-ready'));
      } else {
        video.classList.remove('topg-video-ready');
        video.pause();
        try{video.currentTime=0;}catch(_){}
      }
    }
  });
  buttons.forEach((button,i)=>{
    const active=i===index;button.classList.toggle('is-active',active);
    button.setAttribute('aria-current',active?'true':'false');
  });
 }
 function stop(){clearInterval(timer);timer=0;}
 function start(){stop();if(!reduce.matches&&!document.hidden)timer=setInterval(()=>go(index+1,false),interval);}
 function go(next,manual){
  index=(next+slides.length)%slides.length;sync();
  if(manual){stop();clearTimeout(delayTimer);delayTimer=setTimeout(start,6000);}
 }
 host.querySelector('[data-topg-hero-prev]')?.addEventListener('click',()=>go(index-1,true));
 host.querySelector('[data-topg-hero-next]')?.addEventListener('click',()=>go(index+1,true));
 host.addEventListener('touchstart',e=>{if(e.touches.length===1)xStart=e.touches[0].clientX;},{passive:true});
 host.addEventListener('touchend',e=>{if(xStart===null)return;
   const dx=e.changedTouches[0].clientX-xStart;xStart=null;
   if(Math.abs(dx)>45)go(index+(dx<0?1:-1),true);
 },{passive:true});
 host.addEventListener('mouseenter',stop);
 host.addEventListener('mouseleave',start);
 host.addEventListener('focusin',stop);
 host.addEventListener('focusout',e=>{if(!host.contains(e.relatedTarget))start();});
 document.addEventListener('visibilitychange',()=>{
  if(document.hidden){stop();slides.forEach(s=>s.querySelector('video')?.pause());}
  else{sync();start();}
 });
 reduce.addEventListener?.('change',()=>{if(reduce.matches)stop();else start();});
 sync();start();
};
const boot=()=>{init(document);document.addEventListener('shopify:section:load',e=>init(e.target));};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();